import React from 'react';

function NotyErrorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="45"
      fill="none"
      viewBox="0 0 44 45"
    >
      <g>
        <path
          fill="#fff"
          d="M16.318 20.169c-1.17 0-1.951-.804-1.951-2.01V9.722c0-1.205.78-2.009 1.951-2.009 1.17 0 1.951.804 1.951 2.01v8.438c0 1.004-.975 2.009-1.951 2.009zm12.877-2.01V9.722c0-1.205-.78-2.009-1.95-2.009-1.171 0-1.952.804-1.952 2.01v8.438c0 1.205.78 2.009 1.951 2.009s1.951-1.005 1.951-2.01zM8.904 36.042c2.146-3.616 7.414-6.027 13.072-6.027 5.463 0 10.536 2.21 12.878 5.625.585 1.005 1.756 1.206 2.731.603.976-.603 1.171-1.808.586-2.813-3.122-4.621-9.17-7.434-16-7.434-7.219 0-13.658 3.215-16.39 8.037-.585 1.004-.194 2.21.586 2.813.39.2.586.2.976.2s1.17-.401 1.56-1.004z"
        ></path>
      </g>
    </svg>
  );
}

export default NotyErrorIcon;
